import { createSelector } from "reselect";

import { AltarStore } from "shared/types";

export const getBrowserInfo = () =>
  createSelector(
    (state: AltarStore) => state.browser,
    s => s,
  );
